import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { getJobColor } from '@/lib/jobColors';
import { resolveAssignmentJob } from '@/lib/scheduleData';

export const AssignmentChip = ({ assignment, jobs = [], onClick, compact = false }) => {
  const { t } = useTranslation();
  const { jobName, jobKey } = resolveAssignmentJob(assignment, jobs);
  const color = getJobColor(jobKey || jobName);
  const crew = Array.isArray(assignment?.crew) ? assignment.crew : [];

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(assignment);
      }}
      data-testid={`assignment-chip-${assignment.id}`}
      className={cn(
        'group w-full text-left rounded-sm border px-2 py-1 transition-colors',
        color.chipBg,
        color.border,
        'hover:brightness-110'
      )}
    >
      <div className="flex items-center gap-1.5 min-w-0">
        <span
          aria-hidden
          className={cn('size-1.5 rounded-full shrink-0', color.dot)}
        />
        <span
          className={cn(
            'truncate text-[11px] font-semibold',
            color.chipText
          )}
        >
          {jobName || t('schedule.chip.unassigned')}
        </span>
      </div>
      {!compact ? (
        <div className="mt-0.5 flex items-center gap-1 text-[10px] text-muted-foreground truncate">
          {crew.length === 0 ? (
            <span>{t('schedule.chip.noCrew')}</span>
          ) : (
            <span className="truncate">{crew.join(', ')}</span>
          )}
        </div>
      ) : null}
    </button>
  );
};

export default AssignmentChip;
